import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { AssistanceProgramContent } from './components/AssistanceProgramContent';

export default function AssistanceProgram() {

    return (
        <MainContent
            component={<AssistanceProgramContent />}
            titulo='Programa asistencia al paciente'
            tableMaxWidth
        />
    );

};